import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import * as config from '../shared/config/app.config';
import { BaseService } from '../shared/services/base.service';
@Injectable({
  providedIn: 'root',
})
export class CustomProfileAndPreferencesService {
  userData: any;
  userDataUpdate: any;
  userType: any;
  userRoles: any;
  userSalutation: any;
  passQues: any;
  iframeUrl: any;
  userAccountData: any;
  userProfileAccountData: any;
  userAccountDetails: any;
  userAccountType: any;
  userAccountdetailsType: any;
  cardDetails: any;
  tabClicked: any;
  deleteCard: any;
  deleteCardForEOrder: any;
  updateCardDetails: any;
  profileAndPrefrencesIsActive: any;
  userAccountIdDetails: any;
  states;
  facilityType;
  reccData: any;
  fluData: any;
  receivingHoursUpdated = new Subject();
  futureShipFlagEmitted = new BehaviorSubject(false);
  public influenzaVaccineLocator = new BehaviorSubject<any>(false);
  influenzaVaccineLocator$ = this.influenzaVaccineLocator.asObservable();
  invokeActionsInRecevingHoursComp = new BehaviorSubject('');

  constructor(private readonly baseService: BaseService) {
    this.userDataUpdate = new Subject();
    this.userAccountData = new Subject();
    this.userProfileAccountData = new Subject();
    this.userAccountDetails = new BehaviorSubject('');
    this.userData = new Subject();
    this.userRoles = new Subject();
    this.userSalutation = new Subject();
    this.passQues = new Subject();
    this.iframeUrl = new Subject();
    this.cardDetails = new BehaviorSubject({});
    this.deleteCard = new Subject();
    this.deleteCardForEOrder = new Subject();
    this.updateCardDetails = new Subject();
    this.tabClicked = new Subject();
    this.profileAndPrefrencesIsActive = new Subject();
    this.userAccountIdDetails = new Subject();
    this.states = new Subject();
    this.facilityType = new Subject();
    this.fluData = new Subject();
    this.reccData = new Subject();

  }

  public getUserDataFromDb(idNo) {
    this.baseService.get(config.USER_NAME).subscribe((resp) => {
      if (resp !== null && resp !== undefined && resp?.length !== 0) {
        this.userType = resp.type;
        this.userData.next({ res: resp, id: idNo });
      }
    });
  }

  public updateUserData(params, id?) {
    this.baseService.patch(config.USER_NAME, params).subscribe((res) => {
      if (res == null) {
        id == 'email' ? sessionStorage.setItem('email_request', params.confirmEmail) : '';
        this.userDataUpdate.next(true);
      }
    }, (err) => {
      this.userDataUpdate.next(err);
    });
  }
  public getInfluenzaVaccineLocatorData(userId, acctId) {

    this.baseService.get(`/users/${userId}/${config.INFLUENZA_LOCATION}/${acctId}`, { fields: 'FULL' })
      .subscribe((res: any) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.fluData.next({ res });
        }
      });
  }

  userName: string;
  _userAccountData = new BehaviorSubject(undefined);
  _userAccountDetails = new BehaviorSubject(undefined);

  public getUserAccountDataFromDb(userId): void {
    this.userName = userId;
    this.baseService.get(`${config.USER_ACCOUNT}${userId}/b2bUnits`, { fields: 'FULL' })
      .subscribe((data: any) => {
        if (data !== null && data !== undefined && data?.length !== 0) {
          this.userAccountType = data.type;
          let res = { ...data, userName: userId };
          this.userAccountData.next({ res });
          this._userAccountData.next(res);
        }
      });

  }
  public getUserAccountDetailsDataFromDb(userId, accountId): void {
    // let b2bUid =
    // ('selectedLocations' in sessionStorage && JSON.parse(sessionStorage.getItem('selectedLocations')).length == 1) ?
    // JSON.parse(sessionStorage.getItem('selectedLocations'))[0].accountNumber : accountId;

    this.baseService
      .get(`${config.USER_ACCOUNT}${userId}/b2bUnits/${accountId}`, { fields: 'FULL' })
      .subscribe((res) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          // this.userAccountdetailsType = res.type;
          this.userAccountDetails.next({ res });
          this._userAccountDetails.next(res);
        }
      });
  }

  public getHintQuestions() {
    this.baseService
      .get(`${config.GET_PRACTICEORFACILITYTYPE}`, { enumerationType: 'HintQuestions' })
      .subscribe((res) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.passQues.next(res);
        }
      });
  }
  public getUserRoles() {
    this.baseService.get(`${config.GET_PRACTICEORFACILITYTYPE}`, { enumerationType: 'UserRole' })
      .subscribe((res) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.userRoles.next(res);
        }
      });
  }
  public getUserSalutations() {
    this.baseService
      .get('titles')
      .subscribe((res) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.userSalutation.next(res);
        }
      });
  }
  public getIframeUrl(iFrameForCheckingAc) {
    this.baseService.get(iFrameForCheckingAc ? '/users/current/paymetric/get-iframe-ach' : `/users/current/paymetric/get-iframe`).subscribe((res) => {
      if (res !== null && res !== undefined && res?.length !== 0) {
        this.iframeUrl.next(res);
      }
    });
  }
  public getCardFromDb(userId, id) {
    this.baseService.get(`/users/${userId}/carddetails/${id}`).subscribe((res) => {
      if (res !== null && res !== undefined && res?.length !== 0) {
        this.cardDetails.next(res);
      }
    });
  }

  public getAccountIdFromDb() {
    this.baseService.get(config.GET_ACCOUNT_ID).subscribe((res) => {
      if (res !== null && res !== undefined && res?.length !== 0) {
        this.userAccountIdDetails.next(res);
      }
    });
  }

  public deleteCardFromDb(paymentdetailsId, userId): void {
    // this.baseService.delete(`${config.USER_ACCOUNT}current/paymentdetails/${paymentdetailsId}`, { fields: 'FULL' })
    this.baseService.delete(`${config.USER_ACCOUNT}${userId}/carddetails/${paymentdetailsId}`, { fields: 'FULL' })
      .subscribe((res) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.deleteCard.next(res);
        }
      });
  }

  public deleteCardAuthorizedBy(paymentdetailsId, userId, authorizedBy): void {
    this.baseService.delete(`${config.USER_ACCOUNT}${userId}/carddetails/${paymentdetailsId}/${authorizedBy}`, { fields: 'FULL' })
      .subscribe((res) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.deleteCardForEOrder.next(res);
        }
      });
  }

  public editCardDetails(paymentdetailsId, request, userId): void {
    //this.baseService.patch(`${config.USER_ACCOUNT}current/paymentdetails/${paymentdetailsId}`, request)
    this.baseService.patch(`${config.USER_ACCOUNT}${userId}/carddetails/${paymentdetailsId}`, request)
      .subscribe((res) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.updateCardDetails.next(res);
        }
      });
  }
  // New CAlls
  public updateDeliveryHours(userId, req, b2bUid?): void {
    this.baseService.post(`${config.USER_ACCOUNT}${userId}/b2bUnits/updateDeliveryHours/${b2bUid}`, req).subscribe(res => {
      if (res?.status == 'success') {
        this.receivingHoursUpdated.next(!req.deliveryHours.some(element => element.fromTime != 'Closed'));
      }
    });
  }

  public updateAccountForms(userId,req,b2bUid): Observable<any> {
    return this.baseService.post(`${config.USER_ACCOUNT}${userId}/b2bUnits/updateProfileAccount/${b2bUid}`, req)
  }


  public getStates(): void {
    this.baseService.get(`${config.GET_STATES}`).subscribe(res => {
      this.states.next(res);
    });
  }


  public getFacilityType(params): void {
    this.baseService.get(`${config.GET_PRACTICEORFACILITYTYPE}`, params).subscribe(res => {
      this.facilityType.next(res);
    });
  }

  public getNSetPaymentMethodsNPreference(b2buid, update = false, paymentPreferenceCode?): Observable<{}> {
    return update ? this.baseService.patch(`paymentpreference/${b2buid}/${paymentPreferenceCode}`, { fields: 'DEFAULT' }) :
      this.baseService.get(`paymentpreference/${b2buid}`, { fields: 'DEFAULT' });
  }

  public getAllCardDetails(username): Observable<{}> {
    return this.baseService.get(`${config.USER_ACCOUNT}${username}/carddetails`, { fields: 'DEFAULT' });
  }

  public getUserProfileAccountDetails(userId, b2bUnitId): void {
    this.baseService.get(`${config.USER_ACCOUNT}${userId}/b2bUnits/requestResource/${b2bUnitId}`)
      .subscribe((res: any) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.userProfileAccountData.next({ res });
        }
      });
  }

  public getReccuringReservation(b2bUnitId): void {
    this.baseService.get(`${config.INFLUENZA}${config.INFLUENZA_RECRESERVATION}/${b2bUnitId}`)
      .subscribe((res: any) => {
        if (res !== null && res !== undefined && res?.length !== 0) {
          this.reccData.next({ res });
        }
      });
  }

  public saveReccReservation(b2bUnitId, reccResDetails): Observable<{}> {
    return this.baseService.post(`${config.INFLUENZA}${config.INFLUENZA_RECRESERVATION}/${b2bUnitId}/save-details`, reccResDetails);
  }

  public updateBillingDetails(userId, req, b2bUid): Observable<any> {
    return this.baseService.post(`${config.USER_ACCOUNT}${userId}/b2bUnits/updateBillingDetails/${b2bUid}`, req);
  }
  public fetchProdAllocations(userID, b2bUID = '0140713382'): Observable<any> {
    return this.baseService.get('user/' + userID + '/productallocation/' + b2bUID);
  }

  public checkForYearlyProfileReview(userId) {
    return this.baseService.get(`${config.USER_ACCOUNT}${userId}/b2bUnits/checkUserProfileAnnualReview`);
  }
  public confirmYearlyProfileReview(userId) {
    return this.baseService.get(`${config.USER_ACCOUNT}${userId}/b2bUnits/updateUserProfile`);
  }
  public clearCache(userId) {
    let b2bUid =
      ('selectedLocations' in sessionStorage && JSON.parse(sessionStorage.getItem('selectedLocations')).length == 1) ?
        JSON.parse(sessionStorage.getItem('selectedLocations'))[0].accountNumber : JSON.parse(localStorage.getItem('accountId'));

    return this.baseService
      .get(`${config.USER_ACCOUNT}${userId}/b2bUnits/${b2bUid}/clear`);

  }

  public updateYearlyUserDetails(userId, req): Observable<any> {
    return this.baseService.post(`${config.USER_ACCOUNT}${userId}/anual-user-update`, req)
  }
}

